'use client';

import { Button, ButtonList, ButtonVariant, Modal, ModalBody, ModalFooter, Text } from '@bytel/trilogy-react';

import { paths } from '@helpers/path';

type ModalTlvRedirectProps = {
    onClose: () => void;
};

export function ModalTlvRedirect({ onClose }: Readonly<ModalTlvRedirectProps>) {
    const idFoyerLandingPage = 'tlvctcfai1';
    return (
        <Modal
            accessibilityLabel="Plus qu'une étape avant de finaliser votre commande"
            title="Plus qu'une étape avant de finaliser votre commande !"
            onClose={onClose}
            active
        >
            <ModalBody>
                <Text>
                    Pour vous accompagner dans votre achat, l&apos;un de nos conseillers va vous contacter dans les
                    meilleurs délais.
                </Text>
            </ModalBody>
            <ModalFooter>
                <ButtonList>
                    <Button onClick={onClose} variant={ButtonVariant.SECONDARY}>
                        Fermer
                    </Button>
                    <Button markup='a' href={paths.recall(idFoyerLandingPage)} variant={ButtonVariant.CONVERSION}>
                        Me faire rappeler
                    </Button>
                </ButtonList>
            </ModalFooter>
        </Modal>
    );
}
